"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } }var _react = require('react');



var _useBus = require('shared/hooks/useBus'); var _useBus2 = _interopRequireDefault(_useBus);
var _useOrgAccount = require('shared/hooks/useOrgAccount');

var _user = require('shared/selectors/user');
var _hooks = require('web/services/hooks');
var _myAccounts = require('./myAccounts');

exports.isManagedAccount = _useOrgAccount.isManagedAccount; exports.useSecuritySettingsHome = _useOrgAccount.useSecuritySettingsHome;


const NO_ACCOUNTS = []

// The flagged accounts the user manages: the session's list at once when
// there is one, refreshed by one ListMyAccounts on mount; undefined until
// the first answer, empty when it failed with nothing to show.
 const useAccounts = () => {
  const userKey = _hooks.useAppSelector.call(void 0, _user.selectCurrentUserKey)
  const cached = _react.useSyncExternalStore.call(void 0, _myAccounts.subscribeMyAccounts, () => _myAccounts.getCachedMyAccounts.call(void 0, userKey))
  const [hasFailed, setHasFailed] = _react.useState.call(void 0, false)
  const [version, setVersion] = _react.useState.call(void 0, 0)

  _react.useEffect.call(void 0, 
    () => {
      if (!userKey) return
      let isCurrent = true
      _myAccounts.loadMyAccounts.call(void 0, userKey)
        .then(() => { if (isCurrent) setHasFailed(false) })
        .catch(() => { if (isCurrent) setHasFailed(true) })
      return () => { isCurrent = false }
    },
    [userKey, version],
  )

  const reload = _react.useCallback.call(void 0, () => setVersion(v => v + 1), [])
  _useBus2.default.call(void 0, _useOrgAccount.ROLE_CHANGES, reload)

  const accounts = _nullishCoalesce(cached, () => ( (hasFailed ? NO_ACCOUNTS : undefined)))

  const byOrg = _react.useMemo.call(void 0, 
    () => new Map((_nullishCoalesce(accounts, () => ( []))).flatMap(a => a.OrgKeys.map(k => [k, a] ))),
    [accounts],
  )

  const managedAccounts = _react.useMemo.call(void 0, () => _nullishCoalesce(accounts, () => ( [])), [accounts])

  // The account an org belongs to when the user manages it; null when they
  // don't, undefined until the list loads.
  const accountFor = _react.useCallback.call(void 0, 
    (orgKey) => accounts === undefined ? undefined : _nullishCoalesce(byOrg.get(orgKey), () => ( null)),
    [accounts, byOrg],
  )

  return { accountFor, managedAccounts, isLoading: accounts === undefined, hasFailed, reload }
}; exports.useAccounts = useAccounts
